module.exports = __webpack_public_path__ + "static/media/curitiba-pr.5a1b70b5.jpg";